import {AxiosError} from "axios";
import {needAuth} from "../instance/Instance";

const getContentApproval = (data) => {
    try {
        return needAuth.post(`/contentApproval`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getContentApprovalWithSignature = (data) => {
    try {
        return needAuth.get(`/contentApproval?contentId=${data.contentId}&contentCategory=${data.contentCategory}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export { getContentApproval, getContentApprovalWithSignature };